import "core-js/modules/es.array.push.js";
import AgoraRTCClient from '@/assets/js/rtc-client-ng.js';
import Tool, { addTabTitle, handleLocalStorage } from '@/assets/js/utils.js';
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import { controlDeviceBehavior, controlAudio, controlDevicePublish } from '@/assets/js/attendUser.js';
import VolumeBar from '@/assets/js/volumeBar.js';
export default {
  data() {
    return {
      dealSpeakerHasUnsubscribe: false,
      dealShareHasUnsubscribe: false,
      spearkInfoId: '',
      shareInfoId: '',
      dealHasUnsubscribe: false,
      loadChatMessage: true,
      wsPageSTimer: null,
      rtilStatusObj: {},
      lockName: true,
      allPartyMembers: [],
      userName: '',
      shareInfo: {},
      channels: {},
      rtc: null,
      videoInfo: {},
      devicesInfo: {},
      noCameras: false,
      isShare: false,
      isWeixin: navigator.userAgent.includes('MicroMessenger'),
      shareParams: {},
      partyCode: '',
      rtilCode: 0,
      outPutRtilCode: '',
      sharingMemberId: '',
      inonWindow: false,
      shareRtilCode: 0,
      rtcLoaded: false,
      realPartyCode: '',
      joinPartyCode: '',
      socket: null,
      micCameraFlag: true,
      MeInfo: {},
      managerRtilode: '',
      showMe: true,
      showHost: true,
      userInfo: {},
      ckeckStatusTimer: null,
      setNameInfo: {
        show: false
      },
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      joinParam: {},
      hasBeenTalk: false,
      talkStream: null,
      talkInfo: {},
      hasSetRaiseHand: false,
      raiseLoading: false,
      muteVideoObj: {},
      muteAudioObj: {},
      showPage: false,
      showRightAside: false,
      showUnread: false,
      CameraTips: {
        hideSave: false,
        hideCancel: false,
        showGotIt: false,
        gotIt: 'galleryParticipant.gotIt',
        title: 'galleryParticipant.cameraTips',
        content: '',
        cancel: 'galleryParticipant.deny',
        save: 'galleryParticipant.admit',
        show: false
      },
      nickNameInfo: {},
      organizationInfo: {},
      operationList: ['leaveParty', 'camera', 'mic', 'speaker', 'chat', 'publicChat'],
      collaborateInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      hadOpenWebCloud: false,
      degreeHost: {},
      isAudioLevel: false,
      localVolume: 0
    };
  },
  created() {
    const {
      id
    } = this.$route.query;
    this.State.partyCode = id;
    this.partyCode = id;
    if (id) {
      this.joinPartyLine(id);
    }
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar();
    }
    // 记录与会者进入页面方式
    sessionStorage.setItem('enterPartyType', 'web');
    Bus.$on('setPartyTitle', v => {
      document.title = this.$t('common.partyTitle', {
        name: v.title
      });
    });
    // 获取rtil对应的R的状态
    Bus.$off('pageSerBusCallback');
    Bus.$on('pageSerBusCallback', v => {
      if (v.partyCode != this.$route.query.id) return;
      this.pageSerBusCallback(v);
    });
    Bus.$on('rtilLiveStatus', v => {
      this.rtilStatusObj = v;
    });
    Bus.$off('moveParticipants');
    Bus.$on('moveParticipants', val => {
      var _val$rtilCodes;
      (_val$rtilCodes = val.rtilCodes) === null || _val$rtilCodes === void 0 ? void 0 : _val$rtilCodes.forEach(v => {
        if (v == this.userInfo.rtilCode) {
          this.$router.push({
            name: 'participate',
            query: {
              join_id: val.targetCode,
              moveParticipants: true
            }
          });
        }
      });
    });
    // host控制与会者是否重命名功能
    Bus.$on('setLoginScreenButton', async val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 4) {
        if (operationType === 0) {
          this.lockName = true;
          this.$message.success(this.$t('remainWords.hostLockParticipantName'));
        } else {
          this.lockName = false;
          this.$message.success(this.$t('remainWords.hostUnlockParticipantName'));
        }
      } else if (buttonType === 7) {
        if (operationType) {
          this.hadOpenWebCloud = true;
          if (this.rtc) await this.rtc.leave();
          this.userInfo.status.cloudProxy = 1;
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam);
        } else {
          this.hadOpenWebCloud = false;
          if (this.rtc) await this.rtc.leave('closeCLoudProxy');
          this.userInfo.status.cloudProxy = 0;
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam);
        }
      } else if (buttonType === 13) {
        this.$message.warning(this.$t('setting.muteAllParticipantsTips'));
        this.setOperate({
          type: 'muteAudio',
          id: this.userInfo.rtilCode,
          val: false
        });
      } else if (buttonType === 17) {
        if (operationType === 0) {
          this.isAudioLevel = true;
        } else {
          this.isAudioLevel = false;
        }
      }
    });
    gtag('event', 'pageView-Conference participate', {
      event_category: 'pageView',
      event_label: '会议模块',
      value: 'Conference participate'
    });
    const _self = this;
    Bus.$on('online', v => {
      var _this$allPartyMembers;
      let btn = true;
      // 保证没有重复的
      (_this$allPartyMembers = this.allPartyMembers) === null || _this$allPartyMembers === void 0 ? void 0 : _this$allPartyMembers.forEach(rtilCode => {
        if (rtilCode == v.rtilCode) btn = false;
      });
      if (btn) this.allPartyMembers.push(v.rtilCode);
    });
    Bus.$on('offline', v => {
      var _this$allPartyMembers2;
      (_this$allPartyMembers2 = this.allPartyMembers) === null || _this$allPartyMembers2 === void 0 ? void 0 : _this$allPartyMembers2.forEach((rtilCode, index) => {
        if (v.rtilCode == rtilCode) {
          this.allPartyMembers.splice(index, 1);
        }
      });
    });
    // 接收开启私聊信息
    Bus.$off('startPrivateConversation');
    Bus.$on('startPrivateConversation', v => {
      if (v.rtilCode === _self.rtilCode) {
        this.$message({
          type: 'success',
          message: 'Production Crew has set up a private conversation with you.'
        });
        this.showHost = true;
      } else {
        this.showHost = false;
      }
      this.State.privateInfo = v;
      if (this.userInfo.role == 2 && !v.getByJoin && this.rtc) {
        // 观众需要推流才能私聊
        if (this.State.cameraStatus[this.userInfo.rtilCode]) {
          this.rtc.publish(['video']);
        }
        if (this.State.micStatus[this.userInfo.rtilCode]) {
          this.rtc.publish(['audio']);
        }
      }
    });
    // 接收取消私聊信息
    Bus.$off('cancelPrivateConversation');
    Bus.$on('cancelPrivateConversation', v => {
      if (v.rtilCode === _self.rtilCode && this.State.privateInfo.rtilCode == _self.rtilCode) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.privateConversaitonEnd')
        });
      }
      if (v.rtilCode != _self.rtilCode) {
        var _this$rtc;
        (_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : _this$rtc.subscribe(v.rtilCode, 'all');
      }
      if (this.userInfo.role == 2) {
        var _this$rtc2;
        // 观众取消私聊需要取消推流
        (_this$rtc2 = this.rtc) === null || _this$rtc2 === void 0 ? void 0 : _this$rtc2.unpublish(['video', 'audio']);
      }
      this.showHost = true;
      this.State.privateInfo = {};
    });
    // end party
    Bus.$on('endParty', v => {
      this.$router.push({
        name: 'remove',
        query: {
          type: 'end'
        }
      });
    });
    // 被调度者移除当前会议
    Bus.$off('removeParticipant');
    Bus.$on('removeParticipant', v => {
      if (v.rtilCode === this.userInfo.rtilCode) {
        this.$message({
          type: 'info',
          message: 'Someone has removed you from the party.'
        });
        this.$router.push({
          name: 'remove'
        });
      }
    });
    Bus.$on('denyRaiseHand', result => {
      if (result.rtilCode != this.userInfo.rtilCode) return;
      this.hasSetRaiseHand = false;
    });
    Bus.$on('setQuestioner', result => {
      if (this.userInfo.rtilCode == this.userInfo.status.speaker) {
        var _this$rtc3;
        // 只有speaker需要订阅question的流
        (_this$rtc3 = this.rtc) === null || _this$rtc3 === void 0 ? void 0 : _this$rtc3.subscribe(result.rtilCode, 'all');
      }
      if (result.rtilCode != this.userInfo.rtilCode) return;
      this.userInfo.role = 3; // question
      if (this.State.cameraStatus[this.userInfo.rtilCode] && this.rtc) {
        this.rtc.publish(['video']);
      }
      if (this.State.micStatus[this.userInfo.rtilCode] && this.rtc) {
        this.rtc.publish(['audio']);
      }
    });
    Bus.$on('setQuestionSpeaker', result => {
      const {
        rtilCode
      } = result;
      this.userInfo.status.questionSpeaker = rtilCode;
      if (this.rtc._remotePublishUser[rtilCode]) {
        if (this.rtc._remotePublishUser[rtilCode].hasVideo) {
          var _this$rtc4;
          (_this$rtc4 = this.rtc) === null || _this$rtc4 === void 0 ? void 0 : _this$rtc4.subscribe(rtilCode, 'video');
        }
        if (this.rtc._remotePublishUser[rtilCode].hasAudio) {
          var _this$rtc5;
          (_this$rtc5 = this.rtc) === null || _this$rtc5 === void 0 ? void 0 : _this$rtc5.subscribe(rtilCode, 'audio');
        }
      }
      if (result.rtilCode != this.userInfo.rtilCode) return;
      this.userInfo.role = 5;
      if (this.State.cameraStatus[this.userInfo.rtilCode]) {
        var _this$rtc6;
        (_this$rtc6 = this.rtc) === null || _this$rtc6 === void 0 ? void 0 : _this$rtc6.publish(['video']);
      }
      if (this.State.micStatus[this.userInfo.rtilCode]) {
        var _this$rtc7;
        (_this$rtc7 = this.rtc) === null || _this$rtc7 === void 0 ? void 0 : _this$rtc7.publish(['audio']);
      }
    });
    Bus.$on('setSpeaker', result => {
      this.userInfo.status.speaker = result.rtilCode;
      const _this = this;
      if (_this.rtc._remotePublishUser) {
        var _Object$keys;
        (_Object$keys = Object.keys(_this.rtc._remotePublishUser)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.forEach(rtilCode => {
          if (_this.rtc._remotePublishUser[rtilCode].hasVideo) {
            var _this$rtc8;
            (_this$rtc8 = _this.rtc) === null || _this$rtc8 === void 0 ? void 0 : _this$rtc8.subscribe(rtilCode, 'video');
          }
          if (_this.rtc._remotePublishUser[rtilCode].hasAudio) {
            var _this$rtc9;
            (_this$rtc9 = _this.rtc) === null || _this$rtc9 === void 0 ? void 0 : _this$rtc9.subscribe(rtilCode, 'audio');
          }
        });
      }
      if (result.rtilCode != this.userInfo.rtilCode) return;
      this.userInfo.role = 4;
      setTimeout(() => {
        this.rtc._localVideoTrack.play(`${'local_stream'}`, {
          mirror: true
        });
        if (this.State.cameraStatus[this.userInfo.rtilCode] && this.rtc) {
          this.rtc.publish(['video']);
          this.rtc.setEnabled(true);
        }
        if (this.rtc && this.State.micStatus[this.userInfo.rtilCode]) {
          if (this.rtc._localAudioTrack) {
            controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, true, result => {});
          }
        }
      }, 1000);
      this.operationList = ['leaveParty', 'camera', 'mic', 'speaker', 'share', 'chat', 'publicChat'];
    });
    Bus.$on('cancelQuestioner', result => {
      if (!this.State.privateInfo.crewRtilCode || this.State.privateInfo.crewRtilCode && this.State.privateInfo.crewRtilCode != result.rtilCode) {
        var _this$rtc10;
        (_this$rtc10 = this.rtc) === null || _this$rtc10 === void 0 ? void 0 : _this$rtc10.unsubscribe(result.rtilCode, 'all');
      }
      if (result.rtilCode != this.userInfo.rtilCode) return;
      this.userInfo.role = 2; // reporter
      if (this.State.privateInfo.rtilCode && this.State.privateInfo.rtilCode != this.userInfo.rtilCode) {
        this.rtc.unpublish(['video', 'audio']);
      } else if (this.State.privateInfo.rtilCode && this.State.privateInfo.rtilCode == this.userInfo.rtilCode) {
        this.rtc.unpublish(['video']);
      } else {
        this.rtc.unpublish(['video', 'audio']);
      }
    });
    Bus.$on('cancelSpeaker', result => {
      var _this$rtc11;
      (_this$rtc11 = this.rtc) === null || _this$rtc11 === void 0 ? void 0 : _this$rtc11.unsubscribe(result.rtilCode, 'all');
      if (result.rtilCode == this.userInfo.rtilCode && this.userInfo.rtilCode == this.userInfo.status.speaker) {
        var _Object$keys2;
        this.userInfo.role = 2;
        this.userInfo.status.speaker = '';
        this.operationList = ['leaveParty', 'camera', 'mic', 'speaker', 'chat', 'publicChat'];
        if (!this.State.privateInfo.rtilCode) {
          if (this.rtc._localAudioTrack) {
            this.rtc.unpublish(['audio']);
          }
          if (this.rtc._localVideoTrack) {
            this.rtc.unpublish(['video']);
          }
        }
        setTimeout(() => {
          this.rtc._localVideoTrack.play(`${'local_stream'}`, {
            mirror: true
          });
        }, 1000);
        (_Object$keys2 = Object.keys(this.rtc._remotePublishUser)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.forEach(v => {
          if (!this.roleIdList.includes(+v)) {
            var _this$rtc12;
            // 取消订阅其他人的流
            (_this$rtc12 = this.rtc) === null || _this$rtc12 === void 0 ? void 0 : _this$rtc12.unsubscribe(v, 'all');
          }
        });
        this.shareRtc && this.shareRtc.leave();
      } else {
        this.userInfo.status.speaker = '';
      }
      if (this.shareRtilCode) {
        this.shareScreen('stopShare');
      }
    });
    Bus.$on('cancelQuestionSpeaker', result => {
      var _this$rtc13;
      (_this$rtc13 = this.rtc) === null || _this$rtc13 === void 0 ? void 0 : _this$rtc13.unsubscribe(result.rtilCode, 'all');
      if (result.rtilCode == this.userInfo.rtilCode && this.userInfo.status.questionSpeaker == this.userInfo.rtilCode) {
        this.userInfo.role = 2;
        this.userInfo.status.questionSpeaker = '';
        if (this.State.privateInfo.rtilCode != this.userInfo.rtilCode) {
          this.rtc.unpublish(['video', 'audio']);
        }
      } else {
        this.userInfo.status.questionSpeaker = '';
      }
    });
    Bus.$on('shareScreen', result => {
      var _this$rtc14;
      const res = JSON.parse(result.shareMsg);
      this.shareInfo = res;
      if (!this.State.localShareInfo[res.rtilCode]) (_this$rtc14 = this.rtc) === null || _this$rtc14 === void 0 ? void 0 : _this$rtc14.subscribe(res.rtilCode, 'shareScreen');
    });
    Bus.$on('stopSharing', () => {
      this.cancalShareCommand();
      this.shareInfo = {};
      this.shareRtilCode = '';
      this.shareRtc && this.shareRtc.leave();
    });
    Bus.$on('cancelScreen', () => {
      var _this$rtc15;
      (_this$rtc15 = this.rtc) === null || _this$rtc15 === void 0 ? void 0 : _this$rtc15.unsubscribe(this.shareInfo, 'all');
      this.shareRtc && this.shareRtc.leave();
      this.shareInfo = {};
      this.shareRtilCode = '';
    });
    Bus.$on('controlBehavior', v => {
      const {
        rtilCode,
        behavior
      } = v;
      const {
        key,
        value
      } = behavior;
      if (rtilCode == this.userInfo.rtilCode) {
        if (key == 'camera') {
          if (value == 'true') {
            this.CameraTips.hideSave = false;
            this.CameraTips.hideCancel = false;
            this.CameraTips.showGotIt = false;
            this.CameraTips.show = true;
            this.CameraTips.content = `<div class="end">${this.$t('galleryParticipant.cameraTipCon')}</div>`;
          } else {
            var _this$rtc$_localVideo, _this$rtc$this$realPa, _this$rtc$this$extern;
            // 停止推流
            this.rtc && ((_this$rtc$_localVideo = this.rtc._localVideoTrack) === null || _this$rtc$_localVideo === void 0 ? void 0 : _this$rtc$_localVideo.setEnabled(false));
            (_this$rtc$this$realPa = this.rtc[this.realPartyCode]) === null || _this$rtc$this$realPa === void 0 ? void 0 : _this$rtc$this$realPa.setEnabled(false, 'video');
            (_this$rtc$this$extern = this.rtc[this.externalParty]) === null || _this$rtc$this$extern === void 0 ? void 0 : _this$rtc$this$extern.setEnabled(false, 'video');
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, false);
            this.$message.warning(this.$t('commonFunction.hasCameraOff'));
          }
        }
        if (key == 'mic') {
          if (value == 'true') {
            if (this.rtc._localAudioTrack) {
              controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
            } else {
              // 初始化的时候没有本地音频轨道，需要重新获取
              controlAudio(this.rtc, this.devicesInfo, true, result => {});
            }
          } else {
            var _this$rtc16;
            ((_this$rtc16 = this.rtc) === null || _this$rtc16 === void 0 ? void 0 : _this$rtc16._localAudioTrack) && controlDevicePublish(this.rtc, 'unpublish', [this.rtc._localAudioTrack]);
          }
          // message更换为弹窗
          this.$message.warning(value == 'true' ? this.$t('remainWords.hostHasMicrophoneOn') : this.$t('commonFunction.hasMicrophoneOff'));
          this.$set(this.State.micStatus, this.userInfo.rtilCode, value == 'true');
        }
      }
      if (key == 'nickName' && this.nickNameInfo[rtilCode]) {
        this.$set(this.nickNameInfo, rtilCode, value);
      }
    });
    Bus.$on('setBehaviors', v => {
      const behaviors = v.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          if (val.initiator && val.initiator != this.userInfo.rtilCode && val.mark == this.userInfo.rtilCode) {
            this.$message.success(this.$t('remainWords.hostModifyParticipant'));
          }
          if (val.mark == this.userInfo.rtilCode) {
            this.userName = val.value;
          }
          this.$set(this.nickNameInfo, val.mark, val.value);
        }
        if (val.key === 'organization') {
          this.$set(this.organizationInfo, val.mark, val.value);
        }
      });
    });
    Bus.$on('setOutput', v => {
      const {
        rtilCode
      } = v;
      this.outPutRtilCode = rtilCode;
      this.userInfo.status.output = rtilCode;
    });
    Bus.$on('cancelOutput', v => {
      // 取消之前保存在userInfo里面的数据
      this.userInfo.status.output = '';
    });
    // 处理切换 party 模式
    Bus.$on('clearNotInvited', result => {
      const {
        emailList
      } = result;
      // 判断当前的人是否有登入
      if (this.loginInfo.id) {
        // 判断是否在当前的邀请名单中
        if (!emailList.includes(this.loginInfo.email)) {
          // 跳转到没有权限页面
          this.$router.push({
            name: 'remove',
            query: {
              type: 'noCommonpartyPermission'
            }
          });
        }
      } else {
        var _this$Config$urlInfo;
        // 没有登入跳转到登入页面
        const userServerUrl = (_this$Config$urlInfo = this.Config.urlInfo) === null || _this$Config$urlInfo === void 0 ? void 0 : _this$Config$urlInfo.userservice;
        const publicPath = this.State.publicPath || 'partyline';
        window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}/${publicPath}?join_id=${this.joinPartyCode}&serviceName=Partyline`;
      }
    });
    Bus.$on('clearRemovedInvited', result => {
      const {
        emailList
      } = result;
      if (!emailList.includes(this.loginInfo.email)) {
        this.$router.push({
          name: 'remove',
          query: {
            type: 'noCommonpartyPermission'
          }
        });
      }
    });
    Bus.$on('collaborateInvite', result => {
      const {
        collaborateUserId,
        status
      } = result;
      if (collaborateUserId == this.State.loginInfo.id) {
        status === 0 ? this.collaborateInfo.show = true : this.collaborateInfo.show = false;
        if (status === 0) {
          this.collaborateInfo.info = result;
        } else if (status === 2) {
          this.collaborateInfo.info = {};
        }
      }
    });
    Bus.$on('flipVideo', v => {
      // 与会者getList(Host、anywhere)
      this.$set(this.degreeHost, v.rtilCode, v.degree);
    });
    // 获取party内人数
    this.getMember();
  },
  computed: {
    ...mapState({
      State: state => state,
      isMute: state => state.isMute,
      Config: state => state.config,
      roleType: state => state.roleType,
      loginInfo: state => state.loginInfo
    }),
    roleIdList() {
      const {
        rtilCode,
        status
      } = this.userInfo;
      const {
        managerRtil,
        questionSpeaker,
        speaker,
        output
      } = status;
      const ids = [rtilCode, managerRtil];
      if (questionSpeaker) ids.push(+questionSpeaker);
      if (speaker) ids.push(+speaker);
      if (output) ids.push(+output);
      return ids;
    }
  },
  methods: {
    dealHasUnsubscribes(obj) {
      this.dealHasUnsubscribe = obj.dealHasUnsubscribe;
      this.dealSpeakerHasUnsubscribe = obj.dealHasUnsubscribe;
      this.spearkInfoId = obj.id;
    },
    dealReporterShareHasUnsubscribe(obj) {
      this.dealHasUnsubscribe = obj.dealReporterShareHasUnsubscribe;
      this.dealShareHasUnsubscribe = obj.dealReporterShareHasUnsubscribe;
      this.shareInfoId = obj.id;
    },
    dealSpeakHasUnsubscribe(obj) {
      this.dealHasUnsubscribe = obj.dealInterviewerHasUnsubscribe;
    },
    dealSpeakShareHasUnsubscribe(obj) {
      this.dealHasUnsubscribe = obj.dealShareHasUnsubscribe;
    },
    // dealSpeakQuestionHasUnsubscribe (obj) {
    //   this.dealHasUnsubscribe = obj.dealQuestionHasUnsubscribe
    // },
    controlInvite(val) {
      const params = {
        collaborateLogId: this.collaborateInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (params.optionType == 1) {
            this.$message.success(this.$t('personalInfo.acceptSuccess'));
          } else {
            this.$message.success(this.$t('personalInfo.acceptCancel'));
          }
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    dealFootEvent(info) {
      const {
        type,
        val,
        shareType
      } = info;
      switch (type) {
        case 'muteVideo':
        case 'muteAudio':
          this.setOperate({
            type,
            id: this.userInfo.rtilCode,
            val
          });
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'changeMute':
          this.changeMute(val);
          break;
        case 'showChat':
          this.showRightAside = val;
          break;
        case 'publicChat':
          this.setOperate({
            type: 'raiseHand'
          });
          break;
        case 'leave':
          Bus.$emit('showDialog', {
            show: true,
            realPartyCode: this.partyCode,
            rtilCode: this.userInfo.rtilCode
          });
          break;
        case 'shareScreen':
          this.shareScreen(shareType);
          break;
      }
    },
    switchDevice(obj) {
      if (obj.type == 'speaker') {
        var _this$$refs$speakerBo;
        handleLocalStorage('set', 'speakerId', obj.deviceId);
        // mainWindow切换
        (_this$$refs$speakerBo = this.$refs.speakerBox) === null || _this$$refs$speakerBo === void 0 ? void 0 : _this$$refs$speakerBo.setSpeakerUser();
      }
      this.rtc.setDevice(obj.deviceId, obj.type, result => {
        if (obj.type === 'audio' && result === 'success') {
          var _this$$refs$reporter, _this$$refs$speakerBo2;
          (_this$$refs$reporter = this.$refs.reporter) === null || _this$$refs$reporter === void 0 ? void 0 : _this$$refs$reporter.hasChangeMic();
          (_this$$refs$speakerBo2 = this.$refs.speakerBox) === null || _this$$refs$speakerBo2 === void 0 ? void 0 : _this$$refs$speakerBo2.hasChangeMic();
        }
      });
    },
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.wsPageSTimer = setInterval(() => {
        const rtilCodes = [this.userInfo.rtilCode];
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              rtilCodes: rtilCodes,
              businessId: partyCode
            }),
            module: 'rtilLiveStatus',
            type: 'rtilLiveStatus'
          }),
          serverName: 'partyline'
        };
        if (socket.client.readyState === 1 && rtilCodes.length && partyCode == this.$route.query.id) {
          socket.send(params);
        }
      }, 1000);
    },
    async getNickName(rtilCode, key) {
      if (!this.$route.query.id) return;
      const params = {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.$route.query.id,
        keys: ['nickName', 'organization', 'flipVideo'],
        marks: [rtilCode]
      };
      await this.axios.post('/partyline-backend/behavior/noLogin/getList', params).then(res => {
        const {
          nickName,
          organization
        } = res.data.result[rtilCode];
        this.$set(this.degreeHost, rtilCode, res.data.result[rtilCode].flipVideo);
        this.$set(this.nickNameInfo, rtilCode, nickName);
        this.$set(this.organizationInfo, rtilCode, organization);
      });
    },
    setCameraStatus() {
      // 开启推流
      this.rtc._localVideoTrack && this.rtc._localVideoTrack.setEnabled(true);
      this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
      this.rtc.publish(['video']);
    },
    sendToHost() {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'micCamera',
          rtilCode: this.rtilCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=34694', params).then(async res => {});
    },
    chatCallback(obj) {
      const {
        type,
        data
      } = obj;
      if (type == 'onlineMembers') {
        this.getMember();
      }
      if (type == 'unreadInfo') {
        var _Object$keys3;
        this.showUnread = false;
        (_Object$keys3 = Object.keys(data)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.forEach(keys => {
          if (data[keys].unRead) {
            this.showUnread = true;
          }
        });
      }
      if (type == 'nickName') {
        this.getNickName(obj.rtilCode);
      }
    },
    attendCallback({
      type,
      id,
      val
    }) {
      if (type == 'muteVideo' || type == 'muteAudio') {
        this.setOperate({
          type,
          id,
          val
        });
      } else if (type === 'fullScreen') {
        this.State.fullScreen = val;
        if (val) {
          // this.$refs.coordinatorBox.requestFullscreen()
          document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
        }
      } else if (type === 'audioContext') {
        this.localVolume = val;
      }
    },
    getMember() {
      if (!this.$route.query.id) return;
      this.axios.get(`/partyline-backend/conference/noLogin/onlineMembers/${this.$route.query.id}`).then(res => {
        if (res.data.errorCode === '0x0') {
          var _Object$keys4;
          // 获取所有人的平铺数据
          this.allPartyMembers = [];
          (_Object$keys4 = Object.keys(res.data.result)) === null || _Object$keys4 === void 0 ? void 0 : _Object$keys4.forEach(key => {
            var _res$data$result$key;
            (_res$data$result$key = res.data.result[key]) === null || _res$data$result$key === void 0 ? void 0 : _res$data$result$key.forEach(val => {
              this.allPartyMembers.push(val.rtilCode);
              this.$set(this.nickNameInfo, val.rtilCode, val.nickName);
              this.$set(this.organizationInfo, val.rtilCode, val.organization);
            });
          });
        }
      });
    },
    async shareScreen(shareType) {
      if (!this.shareInfo.rtilCode || shareType) {
        if (shareType === 'stopShare') {
          this.cancalShareCommand({
            id: this.shareInfo.rtilCode
          }, 'byClickShareIcon');
          return;
        }
        const params = {
          memberId: `${handleLocalStorage('get', 'memberId')}_shareScreen`,
          partyCode: this.$route.query.id,
          role: 0,
          type: 3,
          host: false
        };
        this.axios.post('/partyline-backend/party/noLogin/join', params, {
          errorTip: false
        }).then(async res => {
          if (res.data.errorCode === '0x0') {
            const {
              appId,
              tokenCode,
              rtilCode,
              realPartyCode
            } = res.data.result;
            const temp = {
              appId,
              channel: realPartyCode + '',
              token: tokenCode,
              uid: rtilCode,
              share: true,
              subscribeRemote: false,
              status: this.userInfo.status
            };
            this.shareRtilCode = rtilCode;
            await this.sendShareCommand(res.data.result);
            this.shareRtc = new AgoraRTCClient(this.callBack);
            await this.shareRtc.join(temp);
            this.saveShareName(res.data.result);
            this.$set(this.State.localShareInfo, rtilCode, this.userinfo.rtilCode);
            this.isShare = true;
          } else if (res.data.errorCode === '82201504') {
            this.$router.push({
              name: 'remove',
              query: {
                type: 'disableParty'
              }
            });
          }
        });
      } else {
        const shareName = this.shareInfo.initiatorName || 'Someone';
        this.$message({
          type: 'error',
          message: `${shareName}` + this.$t('partylineGuest.isSharing')
        });
      }
    },
    saveShareName({
      rtilCode
    }) {
      if (!rtilCode || !this.userInfo.joinCode) return;
      const params = [{
        mark: String(rtilCode),
        annotation: this.userInfo.joinCode,
        key: 'nickName',
        notify: true,
        value: this.nickNameInfo[this.MeInfo.id] + '_Screen_Share',
        initiator: String(rtilCode)
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {});
    },
    sendShareCommand(shareParams) {
      const {
        rtilCode,
        memberId
      } = shareParams;
      const params = {
        partyCode: this.$route.query.id,
        module: 'shareScreen',
        msg: {
          shareMsg: JSON.stringify({
            rtilCode,
            memberId: this.State.loginInfo.id,
            initiator: this.userInfo.rtilCode,
            nickName: this.userName
          }),
          memberId
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=6416', params);
    },
    cancalShareCommand(byClickShareIcon) {
      if (byClickShareIcon) this.cancelShare();
      const params = {
        partyCode: this.$route.query.id,
        module: 'cancelShareScreen',
        origin: 'conferenceParticipant',
        msg: {
          rtilCode: this.shareRtilCode
        }
      };
      if (!this.shareRtilCode) return;
      this.axios.post('/partyline-backend/party/noLogin/command?key=10798', params).then(res => {
        this.isShare = false;
      });
    },
    cancelShare() {
      if (this.shareRtc && this.shareRtc._shareTrack) {
        this.shareRtc._shareTrack._mediaStreamTrack.stop();
        this.shareRtc && this.shareRtc.leave();
      }
    },
    setNickName(obj) {
      this.userInfo.behavior.nickName = obj.nickName;
      this.userInfo.behavior.organization = obj.organization;
      this.userName = obj.nickName;
      // 只有设置了nickname才可以join到会议
      this.joinAgoraClient(this.userInfo, obj, this.joinParam);
    },
    async subscribeTrack(payload) {
      if (!payload.id) return;
      if (this.talkInfo.rtilCode === payload.id) {
        this.talkStream = payload;
        return;
      }
      try {
        const {
          data: res
        } = await this.axios.post(`/partyline-backend/member/noLogin/queryByRtilCode/${payload.id}`);
        if (res.errorCode == '0x0') {
          const result = res.result;
          const accountId = result.accountId.toLowerCase();
          if (payload.id == this.spearkInfoId) {
            this.dealHasUnsubscribe = this.dealSpeakerHasUnsubscribe;
          } else if (payload.id == this.shareInfoId) {
            this.dealHasUnsubscribe = this.dealShareHasUnsubscribe;
          }
          this.$set(this.channels, payload.id, {
            ...payload,
            tid: res.result.accountId,
            info: {
              rtilCode: payload.id
            },
            shareCode: accountId.indexOf('_sharescreen') > -1 ? payload.id : '',
            hasUnsubscribe: this.dealHasUnsubscribe
          });
        } else {
          setTimeout(() => {
            this.subscribeTrack(payload);
          }, 1000);
        }
      } catch (error) {
        setTimeout(() => {
          this.subscribeTrack(payload);
        }, 1000);
      }
    },
    userLeave(payload) {
      const {
        id
      } = payload;
      if (this.talkInfo.rtilCode === payload.id) this.talkStream = null;
      this.$delete(this.channels, id);
      if (this.State.localShareInfo[id]) this.$delete(this.State.localShareInfo, id);
    },
    async joinPartyLine(partyCode, newRealPartyCode) {
      if (this.socket) {
        this.socket.close(); // 手动停止websocket
        this.socket = null;
        if (this.updataInfoTimer) clearInterval(this.updataInfoTimer);
      }
      if (this.rtc) this.rtc.leave();
      this.rtc = new AgoraRTCClient(this.callBack);
      // 需要先获取设备列表，并判断之前选择过的设备列表是否还存在，不存在则选择默认的
      this.devicesInfo = await this.rtc.getDevice();
      if (!handleLocalStorage('get', 'speakerId')) {
        handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
      }
      if (newRealPartyCode) {
        // 目的是切换party 等待一分钟
        setTimeout(() => {
          this.joinRequest(partyCode, newRealPartyCode);
        }, 1000);
      } else {
        this.joinRequest(partyCode, newRealPartyCode);
      }
    },
    joinRequest(partyCode, newRealPartyCode) {
      const haveHistoryMem = handleLocalStorage('get', 'memberId');
      const params = {
        memberId: haveHistoryMem || 'PL_' + new Date().getTime(),
        partyCode: partyCode,
        role: 0,
        type: 0,
        specifyPartyCode: newRealPartyCode || '',
        specifyRtilCode: newRealPartyCode ? +handleLocalStorage('get', 'rtilCode') : '',
        behaviorKeyList: ['speaker', 'nickName', 'mic', 'camera', 'useCamera', 'flipVideo', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare']
      };
      this.axios.post('/partyline-backend/party/noLogin/join', params, {
        routeName: this.$route.query.from
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          // 控制与会者是否重命名
          result.status.lockName === 0 ? this.lockName = true : this.lockName = false;
          Tool.showPipHotJar(result.status.hotJar !== 0);
          Tool.showChatlio(result.status.Chatlio !== 0);
          addTabTitle({
            userInfo: result
          });
          this.joinParam = {
            ...result,
            partyCode: partyCode,
            memberId: params.memberId
          };
          this.userInfo = res.data.result;
          this.userName = res.data.result.behavior.nickName;
          this.managerRtilode = res.data.result.status.managerRtil;
          this.hasSetRaiseHand = !!result.behavior.raiseHand;
          this.State.joinInfo = result;
          this.State.partyJoinInfo = result;
          this.State.audioType = result.behavior.audioOnlyType ? Number(result.behavior.audioOnlyType) : 0;
          this.State.checkMainWindow = result.behavior.checkAudioMainWindow !== 'false';
          this.State.checkShareScreen = result.behavior.checkAudioShare !== 'false';
          result.status.volumeEffect === 0 ? this.isAudioLevel = true : this.isAudioLevel = false;
          Bus.$emit('changeAudioTypeVal');
          this.$set(this.nickNameInfo, result.rtilCode, this.userName);
          this.$set(this.organizationInfo, result.rtilCode, result.behavior.organization);
          if (result.status.shareScreen) {
            if (this.userInfo.role != 4) this.shareInfo = JSON.parse(result.status.shareScreen);
            if (this.userInfo.rtilCode == JSON.parse(result.status.shareScreen).initiator) {
              this.shareRtilCode = JSON.parse(result.status.shareScreen).rtilCode;
              this.cancalShareCommand();
            }
          }
          if (result.status.speaker == result.rtilCode) {
            this.operationList = ['leaveParty', 'camera', 'mic', 'speaker', 'share', 'chat', 'publicChat'];
          }
          if (result.status.questionSpeaker) {
            this.State.questionerInfo = {
              rtilCode: result.status.questionSpeaker
            };
          }
          if (this.userInfo.status.privateConversation) {
            Bus.$emit('startPrivateConversation', {
              ...JSON.parse(result.status.privateConversation),
              getByJoin: true
            });
          }
          Bus.$emit('updateInitStatus', {
            hasCopy: result.status.hasCopy !== 0
          });
          if (result.behavior && result.behavior.nickName) {
            // 设置过nickname，则不需要重新设置,直接join
            this.setNameInfo.show = false;
            result.behavior.speaker = result.behavior.speaker !== 'false';
            result.behavior.camera = result.behavior.camera !== 'false';
            result.behavior.mic = result.behavior.mic !== 'false';
            this.joinAgoraClient(result, result.behavior, this.joinParam);
          } else {
            this.$router.push({
              name: 'preview',
              query: {
                id: this.partyCode
              }
            });
          }
          Bus.$emit('changePartyAddress', {
            currentId: partyCode,
            title: result.title
          });
        } else if (res.data.errorCode === '80520103') {
          var _this$Config$urlInfo2;
          const userServerUrl = (_this$Config$urlInfo2 = this.Config.urlInfo) === null || _this$Config$urlInfo2 === void 0 ? void 0 : _this$Config$urlInfo2.userservice;
          const publicPath = this.State.publicPath || 'partyline';
          window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}/${publicPath}?join_id=${this.joinPartyCode}&serviceName=Partyline`;
        } else if (res.data.errorCode === '80520104') {
          this.$router.push({
            name: 'remove',
            query: {
              type: 'noCommonpartyPermission'
            }
          });
        } else if (res.data.errorCode === '80520113') {
          this.$message.error(this.$t('partyInfo.partyDisabled'));
        }
      }).catch(err => {
        console.info(err);
        if (err.status === 400) {
          this.$message.error('Not exit party');
          this.$router.push({
            name: 'joinPage'
          });
        }
      });
    },
    joinAgoraClient(result, obj, param) {
      this.showPage = true;
      // 创建通知websocket
      if (!this.State.pageSerBusRequestWs[this.State.partyCode]) {
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode: this.$route.query.id
        });
      }
      // Me设置私聊功能，使用到
      this.MeInfo = {
        id: result.rtilCode,
        tid: handleLocalStorage('get', 'memberId'),
        info: {
          rtilCode: result.rtilCode
        },
        channel: this.partyCode
      };
      this.State.isMute = !obj.speaker;
      this.$set(this.State.cameraStatus, this.userInfo.rtilCode, obj.camera);
      this.$set(this.State.micStatus, this.userInfo.rtilCode, obj.mic);
      this.realPartyCode = result.realPartyCode;
      this.outPutRtilCode = result.outputRtilCode;
      // 默认host设置crew，手动赋值
      this.State.crewInfo.rtilCode = result.status.managerRtil;
      handleLocalStorage('get', 'rtilCode', result.rtilCode);
      handleLocalStorage('get', 'manageRtilCode', result.status.managerRtil);

      // join client
      this.getMeetingInfo(param, result, obj);
    },
    async callBack({
      action,
      payload
    }) {
      const {
        changeDevice,
        id,
        shareInfo
      } = payload;
      switch (action) {
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          Bus.$emit('setSubscribeTrack', payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
        case 'start-share':
          this.shareStream = {
            id,
            videoTrack: shareInfo.videoTrack,
            audioTrack: shareInfo.audioTrack
          };
          break;
        case 'stop-share':
          this.shareInfo = {};
          this.isShare = false;
          this.cancalShareCommand();
          this.shareRtilCode = '';
          this.shareRtc && this.shareRtc.leave();
          break;
        case 'noCameras':
          this.noCameras = true;
          if (this.socket) {
            this.socket.close(); // 手动停止websocket
            this.socket = null;
            if (this.updataInfoTimer) clearInterval(this.updataInfoTimer);
          }
          if (this.State.pageSerBusRequestWs[this.State.partyCode]) {
            this.State.pageSerBusRequestWs[this.State.partyCode].close(); // 手动停止websocket
            this.State.pageSerBusRequestWs[this.State.partyCode] = null;
          }
          if (this.rtc) this.rtc.leave();
          break;
        case 'user-published':
        case 'user-unpublished':
          this.subscribedStream(action, payload);
          this.muteAudioOrVideo(action, payload);
          break;
        case 'local-track':
          const {
            videoTrack,
            audioTrack
          } = payload;
          this.MeInfo = {
            id: this.userInfo.rtilCode,
            tid: this.loginInfo.id,
            nickName: this.userInfo.behavior.nickName,
            info: {
              rtilCode: this.userInfo.rtilCode
            },
            channel: this.partyCode,
            videoTrack: videoTrack,
            audioTrack: audioTrack
          };
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
        case 'cameraChange':
          if (!this.rtc) return;
          this.devicesInfo = await this.rtc.getDevice();
          if (this.rtc._localVideoTrack && changeDevice.device.label === this.rtc._localVideoTrack.getTrackLabel()) {
            const oldCameras = await this.rtc._AgoraRTC.getCameras();
            oldCameras[0] && this.rtc.setDevice(oldCameras[0].deviceId, 'video', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
              this.devicesInfo.cameraId = oldCameras[0].deviceId;
            });
          }
          break;
        case 'micChange':
          if (!this.rtc) return;
          this.devicesInfo = await this.rtc.getDevice();
          if (this.rtc._localAudioTrack && (this.rtc._localAudioTrack._deviceName.includes(changeDevice.device.label) || changeDevice.state === 'INACTIVE' && this.rtc._localAudioTrack._config.microphoneId == 'default')) {
            const oldMic = await this.rtc._AgoraRTC.getMicrophones();
            oldMic[0] && this.rtc.setDevice(oldMic[0].deviceId, 'audio', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewMicSuccess')) : this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
              this.devicesInfo.microphoneId = oldMic[0].deviceId;
              if (type === 'success') {
                var _this$$refs$reporter2, _this$$refs$speakerBo3;
                (_this$$refs$reporter2 = this.$refs.reporter) === null || _this$$refs$reporter2 === void 0 ? void 0 : _this$$refs$reporter2.hasChangeMic();
                (_this$$refs$speakerBo3 = this.$refs.speakerBox) === null || _this$$refs$speakerBo3 === void 0 ? void 0 : _this$$refs$speakerBo3.hasChangeMic();
              }
            });
          } else if (changeDevice.state === 'ACTIVE' && this.rtc._localAudioTrack && !this.rtc._localAudioTrack._deviceName.includes(changeDevice.device.label) && this.rtc._localAudioTrack._config.microphoneId != 'default') {
            var _this$$refs$reporter3, _this$$refs$speakerBo4;
            // 插入mic
            if (this.rtc && this.State.micStatus[v.rtilCode]) {
              if (this.rtc._localAudioTrack) {
                controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
              } else {
                // 初始化的时候没有本地音频轨道，需要重新获取
                controlAudio(this.rtc, this.devicesInfo, true, result => {});
              }
            }
            if (this.devicesInfo.microphoneList[0].label != this.rtc._localAudioTrack._deviceName) {
              this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
            }
            (_this$$refs$reporter3 = this.$refs.reporter) === null || _this$$refs$reporter3 === void 0 ? void 0 : _this$$refs$reporter3.hasChangeMic();
            (_this$$refs$speakerBo4 = this.$refs.speakerBox) === null || _this$$refs$speakerBo4 === void 0 ? void 0 : _this$$refs$speakerBo4.hasChangeMic();
          }
          break;
        case 'playbackChange':
          if (!this.rtc) return;
          if (changeDevice.state !== 'ACTIVE' && this.rtc._localAudioTrack) {
            const currentDeviceId = handleLocalStorage('get', 'speakerId');
            const currentLabelArray = this.devicesInfo.speakerList.filter(item => item.deviceId == currentDeviceId);
            const currentSpeakerList = await this.rtc._AgoraRTC.getPlaybackDevices();
            const haveUseDevice = currentSpeakerList.find(item => item.label == currentLabelArray[0].label);
            if (!haveUseDevice) {
              handleLocalStorage('set', 'speakerId', currentSpeakerList[0].deviceId);
              const array = Object.keys(this.channels).filter(rtilCode => {
                return rtilCode != this.userInfo.rtilCode;
              });
              array.forEach(rtilCode => {
                if (this.channels[rtilCode].audioTrack) {
                  var _this$channels$rtilCo, _this$channels$rtilCo2;
                  (_this$channels$rtilCo = (_this$channels$rtilCo2 = this.channels[rtilCode].audioTrack).setPlaybackDevice) === null || _this$channels$rtilCo === void 0 ? void 0 : _this$channels$rtilCo.call(_this$channels$rtilCo2, currentSpeakerList[0].deviceId);
                }
              });
            }
          }
          this.devicesInfo = await this.rtc.getDevice();
          break;
      }
    },
    async getMeetingInfo(param, result) {
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        memberId,
        videoQualities
      } = param;
      const {
        status
      } = result;
      const params = {
        appId,
        channel: realPartyCode + '',
        token: tokenCode,
        codec: 'h264',
        uid: rtilCode,
        publishVideo: this.State.cameraStatus[this.userInfo.rtilCode] && !(this.userInfo.role == 2 && !this.userInfo.status.privateConversation),
        publishAudio: this.State.micStatus[this.userInfo.rtilCode] && !(this.userInfo.role == 2 && !this.userInfo.status.privateConversation),
        videoConfig: videoQualities,
        video: !!this.devicesInfo.cameraId,
        audio: !!this.devicesInfo.microphoneId,
        // 传入用户选择的可用的音视频采集设备的id
        microphoneId: this.devicesInfo.microphoneId,
        cameraId: this.devicesInfo.cameraId,
        subscribeRemote: false,
        startProxy: result.status.cloudProxy === 1,
        executeLocalSubscribe: true,
        executeVideoAdded: true
      };
      const uid = await this.rtc.join(params);
      if (uid) {
        var _this$rtc18, _this$rtc18$_client;
        this.hadOpenWebCloud = result.status.cloudProxy === 1;
        this.rtcLoaded = true;
        this.rtilCode = rtilCode;
        this.partyCode = realPartyCode;
        this.joinPartyCode = result.joinCode;
        this.State.currentRtilCode = rtilCode;
        handleLocalStorage('set', 'memberId', memberId);
        /// 更改hostjr userId
        const userId = rtilCode + '_' + this.MeInfo.nickName + '_' + this.partyCode;
        window.hj && window.hj('identify', userId, {
          timeStamp: Date.now()
        });
        if (status.output || status.speaker) {
          var _this$rtc17;
          (_this$rtc17 = this.rtc) === null || _this$rtc17 === void 0 ? void 0 : _this$rtc17.subscribe(status.output || status.speaker, 'all');
        }
        (_this$rtc18 = this.rtc) === null || _this$rtc18 === void 0 ? void 0 : (_this$rtc18$_client = _this$rtc18._client) === null || _this$rtc18$_client === void 0 ? void 0 : _this$rtc18$_client.enableAudioVolumeIndicator();
      }
    },
    changeMute(flag) {
      this.$store.dispatch('isMute', !this.isMute);
      if (flag) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOff')
        });
      } else {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOn')
        });
      }
      this.changeBehaviorStatus('speaker', !this.isMute);
    },
    async setOperate({
      type,
      id,
      val
    }) {
      if (type === 'muteVideo' || type === 'muteAudio') {
        let mediaType = '';
        if (type === 'muteVideo') {
          mediaType = 'video';
          this.$set(this.State.cameraStatus, id, val);
        } else {
          this.$set(this.State.micStatus, id, val);
          mediaType = 'audio';
        }
        if (mediaType === 'audio') {
          let operationResult = 'success';
          if (this.rtc._localAudioTrack) {
            const type = val ? 'publish' : 'unpublish';
            operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, val, result => {
              if (result == 'failed') operationResult = 'failed';
            });
          }
          if (operationResult === 'success') {
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'mic',
              value: val,
              partyCode: this.userInfo.joinCode,
              toRtilCode: id
            });
          }
        } else {
          this.setEnabledFn(val, mediaType, id);
        }
      }
      if (type == 'raiseHand') {
        this.setRaiseHand();
      }
    },
    setEnabledFn(value, type, id) {
      this.rtc && this.rtc.setEnabled(value, type, info => {
        if (info === 'failed') {
          this.$set(this.State.cameraStatus, id, !value);
          this.$message.warning(this.$t('common.operationFailed'));
        } else {
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'camera',
            value: value,
            partyCode: this.userInfo.joinCode,
            toRtilCode: id
          });
        }
      });
    },
    setRaiseHand() {
      if (this.hasBeenTalk) {
        this.$message({
          type: 'warning',
          message: 'Operation failed, you are in talking.'
        });
        return;
      }
      const params = {
        partyCode: this.State.partyCode,
        module: this.hasSetRaiseHand ? 'denyRaiseHand' : 'raiseHand',
        msg: {
          rtilCode: this.rtilCode,
          nickName: this.userInfo.behavior.nickName,
          organization: this.userInfo.behavior.organization,
          groupId: this.State.partyCode
        }
      };
      this.hasSetRaiseHand = true;
      if (this.raiseLoading) return;
      this.raiseLoading = true;
      this.axios.post('/partyline-backend/party/noLogin/command?key=39400', params).then(res => {
        if (res.data.errorCode == '0x0') {
          if (params.module === 'raiseHand') {
            this.$message({
              type: 'success',
              message: this.$t('conferenceParticipant.applyPubHostTips')
            });
            this.hasSetRaiseHand = true;
          } else {
            this.$message({
              type: 'success',
              message: this.$t('conferenceParticipant.cancelApplyPubHostTips')
            });
            this.hasSetRaiseHand = false;
          }
        } else {
          this.hasSetRaiseHand = false;
        }
        this.raiseLoading = false;
      });
    },
    changeBehaviorStatus(key, value) {
      if (!this.userInfo.rtilCode || !this.$route.query.id) return;
      // 更新状态
      const params = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.$route.query.id,
        key,
        value: value
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (res.data.errorCode == '0x0') {
          if (key === 'camera') {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, value);
          } else if (key === 'mic') {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, value);
          }
        }
      });
    },
    muteAudioOrVideo(action, payload) {
      const {
        id
      } = payload;
      const value = action === 'user-published';
      payload.mediaType === 'video' ? this.$set(this.State.cameraStatus, id, value) : this.$set(this.State.micStatus, id, value);
    },
    subscribedStream(action, payload) {
      if (action !== 'user-published') return;
      const {
        id
      } = payload;
      let isSubscribe = false;
      const {
        role
      } = this.userInfo;
      if (role == 4) {
        isSubscribe = true;
      } else {
        if (this.roleIdList.includes(id)) isSubscribe = true;
      }
      if (id == this.shareInfo.rtilCode) isSubscribe = true;
      if (isSubscribe) {
        var _this$rtc19;
        (_this$rtc19 = this.rtc) === null || _this$rtc19 === void 0 ? void 0 : _this$rtc19.subscribe(id, payload.mediaType);
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.rtc) {
      this.rtc.leave(this.hadOpenWebCloud ? 'closeCLoudProxy' : '');
    }
    this.socket && this.socket.close();
    if (this.updataInfoTimer) clearInterval(this.updataInfoTimer);
    this.State.crewInfo = {};
    this.State.privateInfo = {};
    if (this.ckeckStatusTimer) clearTimeout(this.ckeckStatusTimer);
    this.shareRtc && this.shareRtc.leave();
    if (this.State.pageSerBusRequestWs[this.State.partyCode]) {
      this.State.pageSerBusRequestWs[this.State.partyCode].close(); // 手动停止websocket
      this.State.pageSerBusRequestWs[this.State.partyCode] = null;
    }
    next();
  }
};